import Image from "../../image";
import NavSlider from "./nav-slider";
import Text from "../../text/text";
import { useNavigationStore } from "../../../store/navigationStore";
import NavDetail from "./nav-detail";
import NavModeSelector from "./nav-mode-selector";
import AIAgentButton from "../../button/ai-agent-button";

interface NavPanelProps {
  onChatClick: () => void;
  isChatActive?: boolean;
}

const NavPanel: React.FC<NavPanelProps> = ({
  onChatClick,
  isChatActive = false,
}) => {
  const currentMode = useNavigationStore((state) => state.currentMode);
  const setShowNavAIPanel = useNavigationStore(
    (state) => state.setShowNavAIPanel
  );

  const chatButton = () => {
    return (
      <div
        onClick={() => {
          onChatClick();
        }}
        className={`relative flex items-center rounded-full btn-style backdrop-blur transition-all duration-300 overflow-hidden ${
          isChatActive ? "actived" : ""
        }`}
      >
        {/* Trigger shows current mode icon when collapsed */}
        <span className="flex items-center justify-center p-[8px] md:px-[20px] h-[40px] shrink-0">
          <Image
            aria-hidden
            src="/assets/icon_chat.png"
            alt="chat icon"
            width={22}
            height={22}
          />{" "}
          <Text text="chat" className="hidden md:block ml-[8px] text-500" />
        </span>
      </div>
    );
  };

  return (
    <div className="p-[20px]">
      <div className="relative">
        <div className="gradient-border-outer">
          <div className="gradient-border md:flex md:h-[72px]">
            {/* Content */}
            <div className="flex">
              <NavDetail />
            </div>

            <div className="flex flex-1 mt-[20px] md:mt-[0px] mb-[32px] md:mb-[0px] md:items-center md:m0">
              <NavSlider currentNavMode={currentMode} />
            </div>

            <div className="flex items-center justify-between gap-3 md:justify-center">
              <div className="flex gap-2">
                <NavModeSelector />
                <AIAgentButton
                  onClick={() => {
                    setShowNavAIPanel(true);
                  }}
                />
              </div>
              {chatButton()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavPanel;
